import { T as t } from "./abstract-base-BwSTXh2a.js";
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const p = (r) => r != null ? r : t;
export {
  p as o
};
